import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "attune-zd-app" }
const _hoisted_2 = {
  key: 0,
  class: "warning-banner"
}
const _hoisted_3 = {
  key: 1,
  class: "warning-banner"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "what-do-we-need-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "accounts" }, "Search accounts", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "users" }, "Search users", -1)
const _hoisted_8 = {
  key: 0,
  value: "producers"
}
const _hoisted_9 = {
  key: 1,
  value: "rollovers"
}
const _hoisted_10 = {
  key: 2,
  value: "nonrenew"
}
const _hoisted_11 = {
  key: 3,
  value: "nonpay"
}
const _hoisted_12 = {
  key: 4,
  value: "uwcancel"
}
const _hoisted_13 = { key: 4 }
const _hoisted_14 = {
  key: 0,
  class: "info-banner",
  id: "js-non-prod-tools"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "SQ target: ", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = {
  key: 0,
  class: "refresh-section"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Please refresh the page to see updated ticket data.", -1)
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductFeedbackSection = _resolveComponent("ProductFeedbackSection")!
  const _component_ProductPromotionSection = _resolveComponent("ProductPromotionSection")!
  const _component_EmailFormSection = _resolveComponent("EmailFormSection")!
  const _component_TicketDataSection = _resolveComponent("TicketDataSection")!
  const _component_HelpCenterRequestSection = _resolveComponent("HelpCenterRequestSection")!
  const _component_AccountSelector = _resolveComponent("AccountSelector")!
  const _component_AccountSection = _resolveComponent("AccountSection")!
  const _component_UserSearch = _resolveComponent("UserSearch")!
  const _component_ProducerSearch = _resolveComponent("ProducerSearch")!
  const _component_SubmitDocuments = _resolveComponent("SubmitDocuments")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.oktaInfoNotFound)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Actions restricted: no Okta login found "))
        : _createCommentVNode("", true),
      (_ctx.isLocal())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Running locally "))
        : _createCommentVNode("", true),
      (_ctx.showProductFeedback && _ctx.hasProductFeedbackPermission && _ctx.isProductFeedbackChannel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_ProductFeedbackSection, {
              currentUser: _ctx.currentUser,
              producerCode: _ctx.producerCode,
              ticketId: _ctx.ticketId,
              userId: _ctx.userId
            }, null, 8, ["currentUser", "producerCode", "ticketId", "userId"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_ProductPromotionSection, {
        producerCode: _ctx.producerCode,
        flag: "attune-wc-summer-incentive"
      }, null, 8, ["producerCode"]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(_component_EmailFormSection, {
          inboundInquiryType: _ctx.formInboundInquiryType,
          formStructure: _ctx.formStructure,
          hasAttachments: _ctx.hasAttachments,
          ticketId: _ctx.ticketId
        }, null, 8, ["inboundInquiryType", "formStructure", "hasAttachments", "ticketId"]), [
          [_vShow, _ctx.showEmailFormView]
        ]),
        _withDirectives(_createVNode(_component_TicketDataSection, {
          inboundInquiryType: _ctx.formInboundInquiryType,
          customFieldValues: _ctx.customFieldValues,
          formStructure: _ctx.formStructure
        }, null, 8, ["inboundInquiryType", "customFieldValues", "formStructure"]), [
          [_vShow, _ctx.showHcfDataView]
        ])
      ], 512), [
        [_vShow, _ctx.showEmailFormView || _ctx.showHcfDataView]
      ]),
      (_ctx.currentView !== 'tickets')
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 3,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentView = $event)),
            class: "search-select"
          }, [
            _hoisted_6,
            _hoisted_7,
            (_ctx.hasProducerSearchPermission)
              ? (_openBlock(), _createElementBlock("option", _hoisted_8, "Search producers"))
              : _createCommentVNode("", true),
            (_ctx.hasLobAccessPermission)
              ? (_openBlock(), _createElementBlock("option", _hoisted_9, "Submit rollover packets"))
              : _createCommentVNode("", true),
            (_ctx.hasLobAccessPermission)
              ? (_openBlock(), _createElementBlock("option", _hoisted_10, "Submit non-renewal notices"))
              : _createCommentVNode("", true),
            (_ctx.hasLobAccessPermission)
              ? (_openBlock(), _createElementBlock("option", _hoisted_11, "Submit non-pay cancellation notices"))
              : _createCommentVNode("", true),
            (_ctx.hasLobAccessPermission)
              ? (_openBlock(), _createElementBlock("option", _hoisted_12, "Submit UW cancellation notices"))
              : _createCommentVNode("", true)
          ], 512)), [
            [_vModelSelect, _ctx.currentView]
          ])
        : _createCommentVNode("", true),
      (_ctx.currentView === 'tickets')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("a", {
              class: "nav-link",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.resetView()), ["prevent"])),
              href: ""
            }, "<< Go Back ")
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_HelpCenterRequestSection, {
          ticketId: _ctx.ticketId,
          requestData: _ctx.helpCenterRequestData,
          automationLevel: _ctx.helpCenterRequestAutomationLevel,
          currentUser: _ctx.currentUser
        }, null, 8, ["ticketId", "requestData", "automationLevel", "currentUser"])
      ], 512), [
        [_vShow, _ctx.currentView === 'tickets']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_AccountSelector, {
          key: _ctx.state.sqBaseUrl,
          selectedAccount: _ctx.selectedAccount,
          "onSelectedAccount:update": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedAccount = $event))
        }, null, 8, ["selectedAccount"]),
        _createVNode(_component_AccountSection, {
          key: _ctx.state.sqBaseUrl,
          onNavigatedRoot: _ctx.navigateToHelpCenterRequest,
          accountId: _ctx.selectedAccount,
          currentUser: _ctx.currentUser,
          userOktaInfo: _ctx.currentUserOktaInfo
        }, null, 8, ["onNavigatedRoot", "accountId", "currentUser", "userOktaInfo"])
      ], 512), [
        [_vShow, _ctx.currentView === 'accounts']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_UserSearch, {
          key: _ctx.state.sqBaseUrl
        })
      ], 512), [
        [_vShow, _ctx.currentView === 'users']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_ProducerSearch, {
          key: _ctx.state.sqBaseUrl
        })
      ], 512), [
        [_vShow, _ctx.currentView === 'producers' && _ctx.hasProducerSearchPermission]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_SubmitDocuments, {
          key: _ctx.state.sqBaseUrl,
          currentUser: _ctx.currentUser,
          submitFunction: _ctx.submitRolloverPacket
        }, null, 8, ["currentUser", "submitFunction"])
      ], 512), [
        [_vShow, _ctx.currentView === 'rollovers' && _ctx.hasLobAccessPermission]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_SubmitDocuments, {
          key: _ctx.state.sqBaseUrl,
          currentUser: _ctx.currentUser,
          submitFunction: _ctx.submitNonPayNotice
        }, null, 8, ["currentUser", "submitFunction"])
      ], 512), [
        [_vShow, _ctx.currentView === 'nonpay' && _ctx.hasLobAccessPermission]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_SubmitDocuments, {
          key: _ctx.state.sqBaseUrl,
          currentUser: _ctx.currentUser,
          submitFunction: _ctx.submitNonRenewalNotice
        }, null, 8, ["currentUser", "submitFunction"])
      ], 512), [
        [_vShow, _ctx.currentView === 'nonrenew' && _ctx.hasLobAccessPermission]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_SubmitDocuments, {
          key: _ctx.state.sqBaseUrl,
          currentUser: _ctx.currentUser,
          submitFunction: _ctx.submitUWCancellationNotice
        }, null, 8, ["currentUser", "submitFunction"])
      ], 512), [
        [_vShow, _ctx.currentView === 'uwcancel' && _ctx.hasLobAccessPermission]
      ])
    ]),
    (_ctx.isNonProd())
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_ctx.getBranch() !== '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createTextVNode(" Current branch: " + _toDisplayString(_ctx.getBranch()) + " ", 1),
                _hoisted_16
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_17,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.sqBaseUrl = $event)),
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleSqChange()))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SQ_URLS_NONPROD, (url) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: url,
                  value: url
                }, _toDisplayString(_ctx.SQ_URL_LABELS[url]), 9, _hoisted_18))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.state.sqBaseUrl]
            ]),
            (_ctx.needsPageRefresh)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}